import { useRef } from 'react';
import { useBrowser } from '../services/BrowserService';

export const useScrollLock = () => {
  const scroll = useRef(false);
  const browser = useBrowser();

  const lockScroll = () => {
    if (!browser?.document) return;

    const html = browser?.document.documentElement;
    const { body } = browser?.document;

    if (!body || !body.style || scroll.current) return;

    let scrollBarWidth = 0;
    let bodyPaddingRight = 0;

    if (browser.window) {
      scrollBarWidth = browser?.window.innerWidth - html.clientWidth;

      bodyPaddingRight = parseInt(
        browser?.window.getComputedStyle(body).getPropertyValue('padding-right'),
      );
    }

    /**
     * 1. Fixes a bug in iOS and desktop Safari whereby setting
     *    `overflow: hidden` on the html/body does not prevent scrolling.
     * 2. Fixes a bug in desktop Safari where `overflowY` does not prevent
     *    scroll if an `overflow-x` stbrowser?.window style is also applied to the body.
     */
    html.classList.add('scroll-locked');
    body.classList.add('scroll-locked');
    body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`;

    scroll.current = true;
  };

  const allowScroll = () => {
    if (!browser?.document) return;

    const html = browser?.document.documentElement;
    const { body } = browser?.document;

    if (!body || !body.style || !scroll.current) return;

    html.classList.remove('scroll-locked');
    body.classList.remove('scroll-locked');
    body.style.paddingRight = '';

    scroll.current = false;
  };

  return { lockScroll, allowScroll };
};
